export default [
  {
    header: "TOOLS",
    icon: "CrosshairIcon",
    children: [
      {
        title: "Action Plan Tool",
        route: "action-plan-tool",
        icon: "CrosshairIcon",
      },
      {
        title: "Working Group Tool",
        route: "working-group-tool",
        icon: "ApertureIcon",
      },
    ],
  },
];
